// @flow
 

import React from 'react';
import {withCssModule} from '@pb/kit-util-with-css-module';
import styles from './svg.module.styl';

import type {StatelessFunctionalComponent} from 'react';
import type {Size, Theme} from '../constants';

const classNames = withCssModule(styles);
const halfFilledClasses = classNames('star-svg__item star-svg__item_half-filled');

/**
 * StarSvg Props
 */
type StarSvgProps = {|
    /**
     * Star is filled
     */
    isFilled: boolean,
    /**
     * Star is filled on a half
     */
    isHalf: boolean,
    /**
     * Star size
     */
    size: Size,
    /**
     * Style of Star
     */
    theme: Theme,
|};


/**
 * The StarSvg component
 *
 * @component
 * @name StarSvg
 * @returns {SVGElement}
 */
const StarSvg: StatelessFunctionalComponent<StarSvgProps> = ({isFilled, isHalf, size, theme}) => {
    const svgClasses = classNames('star-svg', `star-svg_size${size}`, `star-svg_${theme}`);
    const itemClasses = classNames('star-svg__item', {
        'star-svg__item_empty': !isFilled,
        'star-svg__item_filled': isFilled
    });

    return (
        <svg className={svgClasses} viewBox="0 0 512 485">
            <path
                className={itemClasses}
                d="M512,185l-176.9-25.7L256-1l-79.1,160.3L0,185l128,124.8L97.8,485.9L256,402.7l158.2,83.2L384,309.7L512,185L512,185z"
            />

            {isHalf ? <polygon
                    className={halfFilledClasses}
                    points="256,402.3 256,0 177.9,158.3 1,184 129,308.7 98.8,484.9 "
                      /> : null}
        </svg>
    );
};

export default StarSvg;

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../constants");
